import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpService} from "../../http/http.service";
import {Observable} from "rxjs";
import {FeaturesFlagsEnv} from "../../../../environments/domain/features-flags.env";

@Injectable({
  providedIn: 'root'
})
export class FeatureFlagService {
  private url = environment.GESTOR_SOLICITUDES.API_CONSULTAS.PREFIJO_URL;

  constructor(
    private httpService: HttpService
  ) {
  }

  obtenerFeaturesFlags(): Observable<FeaturesFlagsEnv> {
    let headers = this.httpService.getGlobalHeaders()
    return this.httpService.get<FeaturesFlagsEnv>(this.url, `/maestras/features-flags`, null, headers);
  }

  async cargarFeaturesFlags() {
    try {
      environment.FEATURE_FLAGS = await this.obtenerFeaturesFlags().toPromise();
    } catch (error) {
      console.error("Features flags error: ", error);
    }
  }

  featureFlagOn(featureFlagKey: keyof FeaturesFlagsEnv) {
    return environment.FEATURE_FLAGS[featureFlagKey] ?? false;
  }
}
